// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.desc[data-v-283bcf00] {\r\n  color: #999;\r\n  font-size: 12px;\r\n  line-height: 16px;\n}\n.el-input-number.el-input-number--small[data-v-283bcf00] {\r\n  width: 200px;\n}\r\n", ""]);
// Exports
module.exports = exports;
